module.exports = __webpack_public_path__ + "media/src/application/media/svg/icon-15-1a6036e8b95ed84898035ddda27eea42.svg";